import { PageProps } from '..'
import { useProjectPrivateContext } from '../../context/projectContext'
import ProfitLossMembersView from './view'
import { projectPrivate } from '../../higher-order-components/projectPrivate'

type Props = PageProps

const ProfitLossMembersNew = (props: Props) => {
  const { project } = useProjectPrivateContext()

  return <ProfitLossMembersView {...props} currentProject={project} />
}

export default projectPrivate(ProfitLossMembersNew)
